import React, { FunctionComponent } from "react";
import BubbleBackgroundProps from "./BubbleBackgroundProps.interface";
import styles from "./BubbleBackground.module.scss";

const BubbleBackground: FunctionComponent<BubbleBackgroundProps> = (props) => {
    const background = props.content?.color ? props.content.color : "var(--color-just-orange)";
    const bubbleType = props.content?._contentType ? props.content._contentType : "";

    return (
        <div className={styles[bubbleType]} style={{ backgroundColor: background }} />
    );
};

export default BubbleBackground;
